<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
    >
      <login-card header-color="primary">
        <h4 slot="title" class="title" style="color:white">
          {{ $t("Login") }}
        </h4>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>{{ $t("Email") }}...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>{{ $t("Password") }}...</label>
          <md-input
            v-model="password"
            type="password"
            @keyup="keymonitor"
          ></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-simple md-lg md-primary"
          @click="logon"
          >{{ $t("Log On") }}</md-button
        >
        <md-button
          slot="footer"
          class="md-simple md-lg md-primary"
          @click="forgotpassword"
          >{{ $t("Forgot Password") }}</md-button
        >
      </login-card>
      <br />
      <label class="text-danger">{{ $t(errorMsg) }}</label>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import { EventBus } from "@/helpers";

export default {
  components: {
    LoginCard
  },
  data() {
    return {
      email: null,
      password: null,
      errorMsg: ""
    };
  },
  methods: {
    keymonitor(event) {
      if (event.key === "Enter") {
        this.logon();
      }
    },
    logon() {
      this.$store.dispatch("auth/logon", {
        email: this.email,
        password: this.password
      });
    },
    forgotpassword() {
      this.$router.push("/forgotpassword");
    }
  },
  mounted() {
    EventBus.$on("failedLogon", msg => {
      this.errorMsg = msg;
    });
  },
  beforeDestroy() {
    EventBus.$off("failedLogon");
  }
};
</script>

<style>
@media (max-width: 768px) {
  .modal-mask .modal-container {
    margin: auto;
    max-width: 77%;
  }
}

.modal-container {
  max-width: 450px;
  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2),
    0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
}

.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 40px 0px 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
</style>
